export default "__VITE_ASSET__BBo1BrKd__ 1200w";